/**
 * The name a workspace gets when the owner gives it none (design: workspaces d2): the first artist
 * (the lowest account id), else the owner's email. The same rule as `teamWorkspaceName` in
 * music24-api.
 */
export function defaultWorkspaceName(
  accounts: readonly { id: number; name: string | null }[],
  ownerEmail: string
): string {
  let first: { id: number; name: string | null } | null = null;
  for (const account of accounts) {
    if (first === null || account.id < first.id) {
      first = account;
    }
  }
  const firstName = first?.name ?? '';
  return firstName !== '' ? firstName : ownerEmail;
}
